import { COLORS, TYPOGRAPHY } from 'Components/foundation';
import { createStyleSheet } from 'Components/foundation/stylesheets';

export const stylesheet = createStyleSheet({
  container: {
    paddingTop: '36px',
    paddingRight: '54px',
    paddingLeft: '54px',
    gap: '35px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '500px',
  },
  headerContainer: {
    gap: '5px',
  },
  filtersContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    borderRadius: '15px',
    padding: '21px',
    backgroundColor: COLORS.WHITE.DEFAULT,
  },
  inputsContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '20px',
    alignItems: 'center',
    width: '100%',
  },
  statisticsContainer: {
    borderRadius: '15px',
    overflow: 'hidden',
    width: '100%',
    height: '100%',
  },
  iframeContainer: {
    width: '100%',
  },
  title: {
    ...TYPOGRAPHY.HERO_XL_BOLD,
  },
});

export default stylesheet;
